import { useRouter } from '@tanstack/react-router';
import { useRegisterBreadcrumbs } from '@/services/breadcrumbs';
import { generatePath } from '@/services/router/generate-path';

const INTEGRATIONS_INDEX_PATH = '/workspaces/:workspaceId/integrations';

/** Where Cancel returns to — Ember handed off to the Connections tab. */
export function integrationsOverviewHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/integrations/all/overview', { workspaceId });
}

/** Ember's route named this crumb `Segment`, not `Segment source`. */
export function useSegmentOutBreadcrumbs(workspaceId: string): void {
  const router = useRouter();

  useRegisterBreadcrumbs([
    {
      id: 'integrations',
      text: 'Integrations',
      href: generatePath(INTEGRATIONS_INDEX_PATH, { workspaceId }),
    },
    {
      id: 'integrations_segment_out',
      text: 'Segment',
      href: router.buildLocation({
        to: '/workspaces/$workspaceId/integrations/segment_out',
        params: { workspaceId },
      }).href,
    },
  ]);
}
